import { items } from '../getters-types'
import { SET_ITEMS } from '../mutation-types'
import { fetchAll } from '../action-types'

import axios from 'axios'

const state = {
    items: ''
}

const getters = {
    [items]: state => state.items
}

const mutations = {
    [SET_ITEMS](state, data) {
        state.items = data
    }
}

const actions = {
    async [fetchAll]({ commit }, params) {
        try {
            let response = await axios.get('api/kb', { params })
            commit('SET_ITEMS', response.data)
        } catch (error) {
            return false
        }
        return true
    }
}

export default {
    namespaced: true,

    state,
    getters,
    mutations,
    actions
}
